import type { MateriaBorderRadius } from "../types/MateriaBorderRadius"

export const getCssBorderRadius = (radius: MateriaBorderRadius | undefined) => {
  if (radius === undefined) return undefined
  return `var(--border-radius-${radius})`
}
